import Cookies from "js-cookie";
import { TOKEN_NAME, getCookieDomain } from "./utils.js";
export default class BrowserTokenModel {
    tokenName;
    cookieDomain;
    constructor(hostname = null) {
        this.tokenName = TOKEN_NAME;
        this.cookieDomain = getCookieDomain(hostname ? hostname : window.location.hostname);
    }
    getToken() {
        let accessToken = null;
        if (window.location.search.length > 0) {
            for (const [key, value] of window.location.search
                .slice(1)
                .split("&")
                .map(pair => pair.split("="))) {
                if (key == "access_token") {
                    accessToken = value;
                    break;
                }
            }
        }
        if (!accessToken) {
            // NOTE: get은 오직 key만을 인자로 받을 수 있는 것으로 확인되었습니다.
            accessToken = Cookies.get(this.tokenName);
        }
        return accessToken;
    }
    setToken(token) {
        Cookies.set(this.tokenName, token, {
            path: "/",
            domain: this.cookieDomain,
            expires: 365,
        });
    }
    removeToken() {
        Cookies.remove(this.tokenName, {
            domain: this.cookieDomain,
        });
        Cookies.remove(this.tokenName);
    }
    getData() {
        const token = this.getToken();
        if (!token)
            return null;
        //const [header, payload, sign] = token.split(".")
        const payload = token.split(".")[1];
        try {
            return JSON.parse(atob(payload));
        }
        catch (_err) {
            return null;
        }
    }
}
